<template>
  <b-container fluid class="p-0 m-0">
    <header class=" m-3  ">
      <m-nav-301 class="header-rounded" id="nav301"/>
    </header>
  </b-container>
</template>

<script>
export default {
  name: "Header",
  data() {
    return {}
  }
}
</script>

<style>
#nav301 .dashboard-icon{
  color: black !important;
  fill: black !important;
  background: var(--primary) !important;
}
#nav301 .search-input-1-button .search-input-1 .search-input-1-icon {
  color: black !important;
  fill: black !important;
}

</style>

<style scoped>
#nav301 {
  box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px, rgba(17, 17, 26, 0.1) 0px 8px 24px, rgba(17, 17, 26, 0.1) 0px 16px 56px;
}

.header-rounded {
  border-radius: 20px;
}
</style>